import { render, staticRenderFns } from "./SpotlightIndex.vue?vue&type=template&id=28bf2da0&scoped=true&"
import script from "./SpotlightIndex.vue?vue&type=script&lang=js&"
export * from "./SpotlightIndex.vue?vue&type=script&lang=js&"
import style0 from "./SpotlightIndex.vue?vue&type=style&index=0&id=28bf2da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf2da0",
  null
  
)

export default component.exports